import { Button, ButtonsGroup, Modal, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useLegalMentionsModalForm } from '../../../../context/legalMentionsModalFormContext'

interface LegalMentionsModalFooterProps {
  id: string
}

export const LegalMentionsModalFooter = ({ id }: LegalMentionsModalFooterProps): ReactElement => {
  const { t } = useTranslation()
  const { submitForm } = useLegalMentionsModalForm()
  const { close: closeModal } = useModal(id)

  const handleCancelButtonClick = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleApplyButtonClick = useCallback(() => {
    submitForm()
  }, [submitForm])

  return (
    <Modal.Footer>
      <ButtonsGroup>
        <Button onClick={handleCancelButtonClick} variant="text">
          {t('cancel')}
        </Button>
        <Button onClick={handleApplyButtonClick}>
          {t('settings.organization.external_invoice.legal_mentions.modal.apply')}
        </Button>
      </ButtonsGroup>
    </Modal.Footer>
  )
}
